module.exports = __webpack_public_path__ + "static/media/NS_6to.22e0641f.jpg";